import m from "../../geodata/es2015/egyptHigh";
window.am4geodata_egyptHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/egyptHigh.js
// module id = null
// module chunks = 